import React from 'react';

import style from './style/index.scss';

/**
 *
 * @param {Object} props - props object
 * @param {Object} props.i18nParticipation - i18n object
 * @param {JSX.Element} props.showAllScoresButton - button to show all scores
 *
 * @returns {JSX.Element} - main derailment section overview
 */
export function NoRisks(props) {
    const { i18nParticipation, showAllScoresButton } = props;

    return (
        <div>
            <p>{i18nParticipation.report_derailment_no_risks_present}</p>
            <p className={style.showScoresTitle}>
                {i18nParticipation.report_derailment_show_scores_title}

                {showAllScoresButton}
            </p>
        </div>
    );
}
